import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { colors, IconButton } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { Delete } from "@material-ui/icons";
import axios from "axios";
import { uri } from "../../../help/Api";
import { sto } from "../../../Context/InshData";

const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 650,
    },
}));

export default function PricesLevelsTable(props) {
    const { data, setConfirmDialog ,handleDeleteRow,onRowClick} = props;

    const { t } = useTranslation(["forms"]);
    const classes = useStyles();
    const stylH = {
        BorderBottom: "solid 0.5px",
        borderColor: "black",
        fontFamily: "Amiri-Regular",
        fontWeight: "bold",
        fontSize: "1rem",
        color: "#fff"
    }
    const stylRo = {
        BorderBottom: "solid 0.5px",
        borderColor: "gray",
        fontFamily: "Amiri-Regular",
        fontWeight: 700,
        fontSize: 14,
        color: "#000"
    }
    const onRowsClick = async (rowData) => {
        // setFetching(true);
        let Urls = null;
        if (sto.db_name === "" || sto.db_name === null) {
            Urls =`RptSafes/itemUnitSrearch?curr_id=${rowData.item}`
        } else {
            Urls = `RptSafes/itemUnitSrearch?curr_id=${rowData.item}&&db_name=${sto.db_name}`
        }
        await axios
            .get(
                uri +Urls
            )
            .then((res) => {
                // setFetching(false);
                onRowClick(rowData,res.data?.subUnits);
            })
            .catch((err) => {
                // setFetching(false);
            });
    };

    return (
        <TableContainer component={Paper}
        style={{
            maxHeight: 650,minHeight:350
        }}>
            <Table
                size="small" aria-label="a dense table">
                <TableHead>
                    <TableRow
                        style={{
                            backgroundColor: colors.red[300],
                            color: "#000",
                            fontWeight: "bold",
                            fontFamily: "Amiri-Regular",
                            fontSize: 15,
                            border: "solid 0.6px"
                        }}
                    >
                        <TableCell style={stylH} align="center">
                            {t("no")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {"المستوى"}
                        </TableCell>  
                        <TableCell style={stylH} align="center">
                            {t("item")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("unit")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("branch")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("price")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("الحد الادنى")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("الحد الاعلى")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {""}
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((row, i) => (
                        <TableRow key={row.id}
                            style={{
                                padding: "5px 0px",
                                textAlign: "-webkit-center",
                                margin: "0px",
                                whiteSpace: "nowrap",
                                color: "#000",
                                fontWeight: 800,
                                fontFamily: "Amiri-Regular",
                                fontSize: 15,
                                border: "solid 0.6px"
                            }}>
                            <TableCell style={stylRo} align="center" onClick={() => { onRowsClick(row); }}>{row.id}</TableCell>
                            <TableCell style={stylRo} align="center" onClick={() => { onRowsClick(row); }}>{row.levelName}</TableCell>
                            <TableCell style={stylRo} align="center" onClick={() => { onRowsClick(row); }} >{row.itemName}</TableCell>
                            <TableCell style={stylRo} align="center" onClick={() => { onRowsClick(row); }}>{row.unitName}</TableCell>
                            <TableCell style={stylRo} align="center" onClick={() => { onRowsClick(row); }}>{row.branchName}</TableCell>
                            <TableCell style={stylRo} align="center" onClick={() => { onRowsClick(row); }}>{row.price?.toFixed(2)}</TableCell>
                            <TableCell style={stylRo} align="center" onClick={() => { onRowsClick(row); }}>{row.minPrice?.toFixed(2)}</TableCell>
                            <TableCell style={stylRo} align="center" onClick={() => { onRowsClick(row); }}>{row.maxPrice?.toFixed(2)}</TableCell>

                            <TableCell align="center" >
                                <IconButton
                                    color="primary"
                                    aria-label="upload picture"
                                    style={{ maxHeight: "0.7rem" }}
                                    onClick={(e) => {
                                        setConfirmDialog({
                                            isOpen: true,
                                            onConfirm: () => {
                                                handleDeleteRow(e, row);
                                            },
                                        })
                                    }}
                                >
                                    <Delete size={"small"} />
                                </IconButton>

                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
